import { HealthPlanParseResult, HealthPlanProvider } from '../healthPlanTypes';
import { parseBradescoHealthPlanFiles } from './parsers/bradescoParser';
import { parseNotredameHealthPlanFiles } from './parsers/notredameParser';
import { parseUnimedHealthPlanFiles } from './parsers/unimedParser';

// Re-export specific parsers if needed by tests or specific components
export { parseBradescoHealthPlanFiles, parseNotredameHealthPlanFiles, parseUnimedHealthPlanFiles };

type HealthPlanParserFn = (files: File[], password?: string, manualIof?: number) => Promise<HealthPlanParseResult>;

const OBSERVERS: Record<HealthPlanProvider, HealthPlanParserFn> = {
  BRADESCO: parseBradescoHealthPlanFiles,
  NOTREDAME: parseNotredameHealthPlanFiles,
  UNIMED: parseUnimedHealthPlanFiles,
  SULAMERICA: async () => {
    throw new Error('Parser da SulAmérica ainda não implementado.');
  },
  AMIL: async () => {
    throw new Error('Parser da Amil ainda não implementado.');
  },
  PORTO_SEGURO: async () => {
    throw new Error('Parser da Porto Seguro ainda não implementado.');
  },
  GOLDEN_CROSS: async () => {
    throw new Error('Parser da Golden Cross ainda não implementado.');
  },
  SEGUROS_UNIMED: async () => {
    throw new Error('Parser da Seguros Unimed ainda não implementado.');
  },
  SOMPO: async () => {
    throw new Error('Parser da Sompo ainda não implementado.');
  },
  ALLIANZ: async () => {
    throw new Error('Parser da Allianz ainda não implementado.');
  },
  OMINT: async () => {
    throw new Error('Parser da Omint ainda não implementado.');
  },
  ONE_HEALTH: async () => {
    throw new Error('Parser da One Health ainda não implementado.');
  },
  CAIXA_SEGUROS: async () => {
    throw new Error('Parser da Caixa Seguros ainda não implementado.');
  },
  CARE_PLUS: async () => {
    throw new Error('Parser da Care Plus ainda não implementado.');
  },
} as const;

export async function parseHealthPlanFiles(
  provider: HealthPlanProvider | string,
  files: File[],
  password?: string,
  manualIof?: number,
): Promise<HealthPlanParseResult> {
  const normalizedProvider = provider.toUpperCase() as HealthPlanProvider;
  const parser = OBSERVERS[normalizedProvider];

  if (!parser) {
    throw new Error(`Parser não encontrado para o provedor: ${provider} (Normalized: ${normalizedProvider})`);
  }

  return parser(files, password, manualIof);
}
